import type { IconData } from '@stacksjs/iconify-core'

export const arrowheadsUpLeftChevronCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.343 13.657A8 8 0 1 0 13.657 2.343A8 8 0 0 0 2.343 13.657M12.95 8L9.768 4.818h-4.95v4.95L8 12.95V8z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default arrowheadsUpLeftChevronCircle
